import(/* webpackMode: "eager" */ "/app/src/components/pages/tailor-made-iran-tours/Client.tsx")